// extracted by mini-css-extract-plugin
export var pillInput = "PillInput-module--pillInput--94613";
export var pillLabel = "PillInput-module--pillLabel--a3c5a";